<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <v-footer
    class="main-home-container"
    dark
  >
    <v-container fluid>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <div class="text-start">
            {{ parseAttribute('homePage.footer_titles.a') }}
          </div>
          <v-divider class="my-2" />
          <div>
            <div class="text-caption">
              {{ AppSettings.description }}
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <div class="text-start">
            {{ parseAttribute('homePage.footer_titles.b') }}
          </div>
          <v-divider class="my-2" />
          <div class="text-body-2">
            <v-btn
              v-for="(l,ldx) in links"
              :key="`${ldx}-link`"
              :href="l.href"
              :to="l.to"
              block
              class="pa-0 justify-start"
              depressed
              plain
              text
              tile
            >
              {{ parseAttribute(l.label) }}
            </v-btn>
          </div>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <div class="text-start">
            {{ parseAttribute('homePage.footer_titles.c') }}
          </div>
          <v-divider class="my-2" />
          <div class="text-body-2">
            <v-btn
              v-for="(sl,sdx) in [...AppContacts,...AppSocials]"
              :key="`${sdx}-sdx`"
              :block="!!sl.label"
              :class="{'justify-start': !!sl.label && !!sl.icon}"
              :href="sl.url || sl.href || undefined"
              :icon="!sl.label && !!sl.icon"
              :text="!!sl.label"
              :to="sl.to"
              v-bind="sl.attrs"
            >
              <v-icon
                v-if="!!sl.icon"
                :left="!!sl.label"
              >
                {{ sl.icon }}
              </v-icon>
              <span
                v-if="!!sl.label"
                :class="sl.span"
              >{{ sl.label }}</span>
            </v-btn>
          </div>
        </v-col>
        <v-col
          class="text-center"
          cols="12"
          md="3"
        >
          <div>
            {{ $t('auth_by') }}
          </div>
          <v-divider class="my-2" />
          <div class="my-6 pa-2 white rounded">
            <v-img
              contain
              height="30px"
              src="/assets/images/fal.png"
              width="100%"
            />
          </div>
          <div class="text-body-2">
            {{ $t('auth_no', { n: '1200048282' }) }}
          </div>
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
        <v-col cols="12">
          <div class="text-start text-caption">
            {{ copyright }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { MetaInfoMixin } from '@mixins'
import { APP_ROUTES } from '@routes/list'

export default {
  name: 'MainFooter',
  mixins: [MetaInfoMixin],
  data: () => ({
    links: [
      {
        label: 'homePage.aboutCompany',
        to: { name: APP_ROUTES.homePage, hash: '#about' }
      },
      {
        label: 'homePage.partners',
        to: { name: APP_ROUTES.homePage, hash: '#partners' }
      },
      {
        label: 'homePage.links.products',
        to: { name: APP_ROUTES.homePage, hash: '#products' }
      },
      {
        label: 'homePage.links.order',
        to: { name: APP_ROUTES.public.apply }
      }
    ]
  }),
  methods: {}
}
</script>

<style scoped>
/*.copyright{*/
/*  color: var(--v-footer-lighten5);*/
/*}*/
</style>
